// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwCheckBox-wrap","control":"CwCheckBox-control","checkbox":"CwCheckBox-checkbox","controlDisabled":"CwCheckBox-controlDisabled","checkboxChecked":"CwCheckBox-checkboxChecked","checkboxCheckedDisabled":"CwCheckBox-checkboxCheckedDisabled","checkboxDisabled":"CwCheckBox-checkboxDisabled","controlInvalid":"CwCheckBox-controlInvalid","checkboxInvalid":"CwCheckBox-checkboxInvalid","checkboxCheckedInvalid":"CwCheckBox-checkboxCheckedInvalid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwcheckbox/CwCheckBox.scss
// module id = 354
// module chunks = 0